import React, { useMemo } from "react";
import { diffNotes } from "./noteDiffUtils";
import { transcriptNoteModalColumnText } from "./supportStyles";

const DiffLegend = () => (
  <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-gray-600 shrink-0">
    <span className="inline-flex items-center gap-1.5">
      <span className="inline-block w-3 h-3 rounded-sm bg-green-200 border border-green-300" />
      Added to final note
    </span>
    <span className="inline-flex items-center gap-1.5">
      <span className="inline-block w-3 h-3 rounded-sm bg-red-100 border border-red-300 line-through text-[10px] text-red-800 px-0.5">
        x
      </span>
      Removed from final note
    </span>
  </div>
);

const NoteDiffView = ({ aiNote, finalNote }) => {
  const parts = useMemo(() => diffNotes(aiNote, finalNote), [aiNote, finalNote]);

  const isIdentical =
    (aiNote || "").trim() === (finalNote || "").trim() &&
    (aiNote || "").trim().length > 0;

  if (!finalNote?.trim() && !aiNote?.trim()) {
    return (
      <p className={`${transcriptNoteModalColumnText} text-gray-500`}>
        Both notes are empty.
      </p>
    );
  }

  return (
    <div className="flex flex-col flex-1 min-h-0 h-full gap-2">
      <DiffLegend />
      {isIdentical ? (
        <p className="text-xs text-gray-500 shrink-0">
          Final note matches the AI note exactly.
        </p>
      ) : null}
      <div
        className={`flex-1 min-h-0 overflow-auto px-3 py-2 border border-gray-300 rounded-md bg-white ${transcriptNoteModalColumnText} whitespace-pre-wrap break-words`}
      >
        {parts.map((part, index) => {
          if (part.type === "equal") {
            return <span key={index}>{part.value}</span>;
          }
          if (part.type === "insert") {
            return (
              <span
                key={index}
                className="bg-green-200 text-green-950 rounded-sm"
              >
                {part.value}
              </span>
            );
          }
          return (
            <span
              key={index}
              className="bg-red-100 text-red-900 line-through decoration-red-700 rounded-sm"
            >
              {part.value}
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default NoteDiffView;
